// @flow

export const getTrackAppUrl = (
  refererFallback: string = 'https://toggl.space'
) => {
  const url = new URL(
    typeof window === 'undefined' ? refererFallback : window.location
  )

  if (/toggl\.(com|space)$/.test(url.hostname)) {
    return `${url.protocol}//track.${url.host}`
  }

  return 'https://track.toggl.space'
}
